import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../../firestore-config";
import { useStore } from "../../../app/stores/rootStore";

export default observer(function LoginPage() {
    const { userStore } = useStore();
    const navigate = useNavigate();
    
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleEmailLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            await userStore.login({email, password});
            navigate("/dashboard");
        } catch (err: any) {
            setError("Invalid email or password. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleLogin = async () => {
        setLoading(true);
        try {
            await signInWithPopup(auth, googleProvider);
            // userStore listener handles the state change and cart sync
            navigate("/dashboard");
        } catch (err) {
            setError("Google sign-in failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="form1 cid-uATOSlQKYb py-5 bg-light min-vh-100 d-flex align-items-center">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-8">
                        <div className="card border-0 shadow-lg rounded-4 p-4 p-md-5 bg-white">
                            <div className="text-center mb-4">                                
                                <h2 className="fw-bold mbr-section-title">Welcome Back</h2>
                                <p className="text-muted small">Login to manage your orders and wishlist</p>
                            </div>

                            {error && <div className="alert alert-danger small py-2">{error}</div>}

                            <form onSubmit={handleEmailLogin}>
                                <div className="mb-3">
                                    <label className="form-label small fw-bold">Email Address</label>
                                    <input 
                                        type="email" 
                                        className="form-control form-control-lg rounded-3 fs-6" 
                                        placeholder="name@example.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="form-label small fw-bold">Password</label>
                                    <input 
                                        type="password" 
                                        className="form-control form-control-lg rounded-3 fs-6" 
                                        placeholder="••••••••"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>

                                <button 
                                    type="submit" 
                                    className="btn btn-danger btn-lg w-100 rounded-pill mb-3 py-3 fw-bold shadow-sm"
                                    disabled={loading}
                                >
                                    {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : "Login"}
                                </button>
                            </form>

                            <div className="text-center my-3 position-relative">
                                <hr />
                                <span className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted small">OR</span>
                            </div>

                            <button onClick={handleGoogleLogin} className="btn btn-dark w-100 fw-bold">
                                    Login with Google to Checkout
                                </button>

                            <p className="text-center mt-4 mb-0 small">
                                Don't have an account? <Link to="/register" className="text-danger fw-bold">Register</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});